import ProductCardMadeCanvasClass from "components/jiffy/product-card-v3/made-canvas/made-canvas-class";

export default class DesignUploadCtaPlpPreviewClass {
  static #filePreviewSelector = ".js-upload-image-preview";

  static #filePreviewImgSelector = ".js-upload-image-preview-img";

  #url;

  constructor(props) {
    this.#url = props.url;
  }

  static get #$filePreview() {
    return document.querySelector(DesignUploadCtaPlpPreviewClass.#filePreviewSelector);
  }

  static get #$filePreviewImg() {
    return document.querySelector(DesignUploadCtaPlpPreviewClass.#filePreviewImgSelector);
  }

  #showImagePreview() {
    DesignUploadCtaPlpPreviewClass.#$filePreview.classList.remove("hidden");
    DesignUploadCtaPlpPreviewClass.#$filePreviewImg.src = this.#url;
  }

  static #hideImagePreview() {
    DesignUploadCtaPlpPreviewClass.#$filePreview.classList.add("hidden");
    DesignUploadCtaPlpPreviewClass.#$filePreviewImg.src = "";
  }

  show() {
    this.#showImagePreview();
    new ProductCardMadeCanvasClass({ url: this.#url }).init();
  }

  static async hide() {
    DesignUploadCtaPlpPreviewClass.#hideImagePreview();
    ProductCardMadeCanvasClass.setDefaultPreviewSrc();
  }
}
